import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import AuthContext from './AuthContext';
import {
  signIn, signOut, getUser, signUp, forgotPassword, confirmForgotPassword, confirmSignUp, resendsignupConfirmationCode,
} from './auth';

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  // const [loading, setLoading] = useState(false);

  useEffect(() => {
    const retrieveUser = async () => {
      try {
        const currentUser = await getUser();
        setUser(currentUser);
      } catch (err) {
        console.error('Failed to retrieve user');
      }
    };
    retrieveUser();
  }, []);

  async function login(email, password) {
    try {
      console.log(email);
      const newUser = await signIn(email, password);
      setUser(newUser);
      setError('');
    } catch (err) {
      setError('Invalid username / password');
      setUser(null);
      setTimeout(() => {
        setError('');
      }, 5000); // hide error after 5 seconds
    }
  }

  async function forgotPwd(username) { // send confirmation code
    try {
      // console.log(email);
      const result = await forgotPassword(username);
      console.log(result);
    } catch (err) {
      setUser(null);
    }
  }

  async function changePwd(username, code, password) { // send confirmation code
    try {
      // console.log(email);
      await confirmForgotPassword(username, code, password);
    } catch (err) {
      setUser(null);
    }
  }

  async function confirmsignupp(username, password) { // send confirmation code
    try {
      // console.log(email);
      await confirmSignUp(username, password);
      setUser(username);
    } catch (err) {
      setUser(null);
    }
  }

  async function resendSignUp(username) { // resend confirmation code
    try {
      // console.log(email);
      await resendsignupConfirmationCode(username);
    } catch (err) {
      setUser(null);
    }
  }
  async function signing(email, password) {
    try {
      console.log(email, password);
      await signUp(email, password);
      // setUser(newUser.username);
      // console.log(user);
    } catch (err) {
      setUser(null);
      console.log(err);
    }
  }

  async function logout() {
    try {
      await signOut();
      setUser(null);
    } catch (err) {
      setUser(null);
    }
  }

  return (
    <AuthContext.Provider
      value={useMemo(() => ({
        user,
        error,
        login,
        logout,
        signing,
        forgotPwd,
        changePwd,
        confirmsignupp,
        resendSignUp,
      }), [user, error])}
    >
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
